/* Rozwala storefront behaviours.
   - One-tap add from product cards / sticky bar / bundles, using Dawn's cart drawer.
   - Delivery-date estimate from a pincode (estimate only, stored locally).
   - Sticky buy bar hides while the real buy button is visible.
   No frameworks; runs after DOM is parsed (loaded with defer). */
(function () {
  'use strict';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var drawer = function () { return document.querySelector('cart-drawer'); };

  /* ---------------- cart ---------------- */
  function addItems(items) {
    var d = drawer();
    var body = { items: items };
    if (d && typeof d.getSectionsToRender === 'function') {
      body.sections = d.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (json) {
        if (d && typeof d.renderContents === 'function') {
          d.classList.remove('is-empty');
          d.renderContents(json);           // Dawn re-renders and opens the drawer
        } else {
          window.location.href = root + 'cart';
        }
        return json;
      });
  }

  function withLoading(btn, promise) {
    var label = btn.innerHTML;
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    return promise.then(function () {
      btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
      btn.classList.add('is-done'); btn.innerHTML = btn.getAttribute('data-rz-done') || 'Added';
      setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = label; }, 1600);
    }).catch(function (err) {
      btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
      btn.innerHTML = (err && (err.description || err.message)) ? 'Not available' : 'Try again';
      setTimeout(function () { btn.innerHTML = label; }, 2200);
    });
  }

  document.addEventListener('click', function (e) {
    var one = e.target.closest('[data-rz-add]');
    if (one) {
      e.preventDefault();
      var id = parseInt(one.getAttribute('data-rz-add'), 10);
      var qty = parseInt(one.getAttribute('data-rz-qty') || '1', 10);
      if (id) withLoading(one, addItems([{ id: id, quantity: qty }]));
      return;
    }
    var many = e.target.closest('[data-rz-add-many]');
    if (many) {
      e.preventDefault();
      var items = many.getAttribute('data-rz-add-many').split(',').map(function (p) {
        var kv = p.split(':'); return { id: parseInt(kv[0], 10), quantity: parseInt(kv[1] || '1', 10) };
      }).filter(function (i) { return i.id; });
      if (items.length) withLoading(many, addItems(items));
      return;
    }
    var sticky = e.target.closest('[data-rz-sticky]');
    if (sticky) {
      e.preventDefault();
      var form = document.querySelector('product-form form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
      var multi = sticky.getAttribute('data-rz-multi') === 'true';
      if (multi && form) {
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var sel = form.querySelector('variant-selects, variant-radios, .product-form__input');
        if (sel) { sel.classList.add('rz-flash'); setTimeout(function () { sel.classList.remove('rz-flash'); }, 1200); }
        return;
      }
      var vid = parseInt(sticky.getAttribute('data-rz-variant'), 10);
      if (form) {
        var hidden = form.querySelector('input[name="id"]');
        if (hidden && hidden.value) vid = parseInt(hidden.value, 10);
      }
      if (vid) withLoading(sticky, addItems([{ id: vid, quantity: 1 }]));
    }
  });

  /* ---------------- sticky buy bar ---------------- */
  var bar = document.querySelector('.rzsb');
  if (bar) {
    document.body.classList.add('rz-has-sticky');
    var realBtn = document.querySelector('.product-form__submit');
    if (realBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-hidden', entries[0].isIntersecting);
      }, { threshold: 0.2 }).observe(realBtn);
    }
    // keep the price in sync when Dawn swaps variants (it re-renders the price block)
    var priceSrc = document.querySelector('.product .price--large');
    if (priceSrc && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var sale = priceSrc.querySelector('.price-item--sale, .price-item--regular');
        var out = bar.querySelector('[data-rz-sticky-price]');
        if (sale && out) out.textContent = sale.textContent.trim();
      }).observe(priceSrc, { childList: true, subtree: true, characterData: true });
    }
  }

  /* ---------------- pincode delivery estimate ---------------- */
  function fmt(d) {
    return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
  }
  function estimate(pin, days) {
    var d = new Date();
    var n = days;
    if (d.getHours() >= 14) n += 1;                 // cut-off: orders after 2pm ship next day
    var p = String(pin || '');
    if (/^(1|2|3)/.test(p) === false) n += 1;       // outside north India: +1 day (rough estimate)
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; }  // skip Sundays
    return d;
  }
  var saved = null;
  try { saved = localStorage.getItem('rz_pin'); } catch (e) {}
  document.querySelectorAll('[data-rz-pin]').forEach(function (box) {
    var input = box.querySelector('input'), btn = box.querySelector('[data-rz-pin-check]');
    var out = box.querySelector('[data-rz-pin-out]'), days = parseInt(box.getAttribute('data-rz-days') || '2', 10);
    function run() {
      var v = (input.value || '').replace(/\D/g, '').slice(0, 6);
      input.value = v;
      if (v.length !== 6) { out.innerHTML = '<div>Enter a 6-digit pincode</div>'; return; }
      try { localStorage.setItem('rz_pin', v); } catch (e) {}
      out.innerHTML = '<div>Delivery by <b>&nbsp;' + fmt(estimate(v, days)) + '</b></div><div>COD available</div><small>Estimate for ' + v + ' · dispatched from Lucknow within 24 hrs</small>';
      document.querySelectorAll('[data-rz-loc]').forEach(function (el) { el.textContent = v; });
    }
    if (btn) btn.addEventListener('click', run);
    if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
    if (saved && input && !input.value) { input.value = saved; run(); }
  });
  if (saved) document.querySelectorAll('[data-rz-loc]').forEach(function (el) { el.textContent = saved; });
})();
